import * as apis from "../../apis";
import * as errors from "../../errors";
import * as successes from "../../successes";
import {getAxiosTokenConfig} from "../../helpers";
import axios from "../../axios/axios";


import {notifyError, notifySuccess} from "../../toast-notifications";
import { CLOSE_ZONE_MODAL } from "./ui";
import { zoneRefresh } from "./autoRefresh";
import { ALL_ZONES_ID } from "../../constants";
import { getTables, getArtefacts } from "./index";

// GET ZONES
export const GET_ZONES_REQUEST = "GET_ZONES_REQUEST";
export const GET_ZONES_SUCCESS = "GET_ZONES_SUCCESS";
export const GET_ZONES_ERROR = "GET_ZONES_ERROR";

export const getZonesRequest = () => {
    return {
        type: GET_ZONES_REQUEST,
        loading: true
    };
};
export const getZonesSuccess = (zones) => {
    return {
        type: GET_ZONES_SUCCESS,
        loading: false,
        error: null,
        zones
    };
};
export const getZonesError = (error) => {
    return {
        type: GET_ZONES_ERROR,
        loading: false,
        error
    };
};

export const getZones = () => {
    return dispatch => {
        dispatch(getZonesRequest());
        axios.get(apis.ZONES_API , getAxiosTokenConfig())
            .then(response => {
                dispatch(getZonesSuccess(response.data));
            })
            .catch(error => {
                dispatch(getZonesError(errors.GET_ZONES_ERROR));
                notifyError(errors.GET_ZONES_ERROR);
            });
    };
};

// ADD ZONE
export const ADD_ZONE_REQUEST = "ADD_ZONE_REQUEST";
export const ADD_ZONE_SUCCESS = "ADD_ZONE_SUCCESS";
export const ADD_ZONE_ERROR = "ADD_ZONE_ERROR";

export const addZoneRequest = () => {
    return {
        type: ADD_ZONE_REQUEST,
        loading: true
    };
};
export const addZoneSuccess = (zone) => {
    return {
        type: ADD_ZONE_SUCCESS,
        loading: false,
        error: null,
        zone
    };
};
export const addZoneError = (error) => {
    return {
        type: ADD_ZONE_ERROR,
        loading: false,
        error
    };
};

export const addZone = (zone) => {
    return dispatch => {
        dispatch(addZoneRequest());
        axios.post(apis.ZONES_API , zone, getAxiosTokenConfig())
            .then(response => {
                dispatch(addZoneSuccess(response.data));
                notifySuccess(successes.ADD_ZONE_SUCCESS);
            })
            .catch(error => {
                dispatch(addZoneError(errors.ADD_ZONE_ERROR));
                notifyError(errors.ADD_ZONE_ERROR);
            })
            .finally(() => {
                dispatch({type: CLOSE_ZONE_MODAL});
            });
    };
};

// DELETE ZONE
export const DELETE_ZONE_REQUEST = "DELETE_ZONE_REQUEST";
export const DELETE_ZONE_SUCCESS = "DELETE_ZONE_SUCCESS";
export const DELETE_ZONE_ERROR = "DELETE_ZONE_ERROR";

export const deleteZoneRequest = () => {
    return {
        type: DELETE_ZONE_REQUEST,
        loading: true
    };
};
export const deleteZoneSuccess = (zoneId) => {
    return {
        type: DELETE_ZONE_SUCCESS,
        loading: false,
        error: null,
        zoneId
    };
};
export const deleteZoneError = (error) => {
    return {
        type: DELETE_ZONE_ERROR,
        loading: false,
        error
    };
};

export const deleteZone = (zoneId) => {
    return (dispatch, getState) => {
        dispatch(deleteZoneRequest());
        axios.delete(apis.ZONES_BY_ID_API(zoneId), getAxiosTokenConfig())
            .then(response => {
                dispatch(deleteZoneSuccess(response.data));
                dispatch(getTables());
                dispatch(getArtefacts());
                dispatch(getZoneItems());
                notifySuccess(successes.DELETE_ZONE_SUCCESS);
                if(getState().zoneReducer.currentZone === zoneId)
                    dispatch(setCurrentZone(ALL_ZONES_ID));
            })
            .catch(error => {
                dispatch(deleteZoneError(errors.DELETE_ZONE_ERROR));
                notifyError(errors.DELETE_ZONE_ERROR);
            })
            .finally(() => {
                dispatch({type: CLOSE_ZONE_MODAL});
                dispatch(zoneRefresh());
            });
    };
};

// UPDATE ZONE
export const UPDATE_ZONE_REQUEST = "UPDATE_ZONE_REQUEST";
export const UPDATE_ZONE_SUCCESS = "UPDATE_ZONE_SUCCESS";
export const UPDATE_ZONE_ERROR = "UPDATE_ZONE_ERROR";

export const updateZoneRequest = () => {
    return {
        type: UPDATE_ZONE_REQUEST,
        loading: true
    };
};
export const updateZoneSuccess = (zone) => {
    return {
        type: UPDATE_ZONE_SUCCESS,
        loading: false,
        error: null,
        zone
    };
};
export const updateZoneError = (error) => {
    return {
        type: UPDATE_ZONE_ERROR,
        loading: false,
        error
    };
};

export const updateZone = (zone) => {
    return dispatch => {
        dispatch(updateZoneRequest());
        axios.patch(apis.ZONES_BY_ID_API(zone.id), zone, getAxiosTokenConfig())
            .then(response => {
                dispatch(updateZoneSuccess(response.data));
                dispatch(getTables());
                dispatch(getArtefacts());
                dispatch(getZoneItems());
                notifySuccess(successes.UPDATE_ZONE_SUCCESS);
            })
            .catch(error => {
                dispatch(updateZoneError(errors.UPDATE_ZONE_ERROR));
                notifyError(errors.UPDATE_ZONE_ERROR);
            })
            .finally(() => {
                dispatch({type: CLOSE_ZONE_MODAL});
            });
    };
};

// GET ZONE ITEMS
export const GET_ZONE_ITEMS_REQUEST = "GET_ZONE_ITEMS_REQUEST";
export const GET_ZONE_ITEMS_SUCCESS = "GET_ZONE_ITEMS_SUCCESS";
export const GET_ZONE_ITEMS_ERROR = "GET_ZONE_ITEMS_ERROR";

export const getZoneItemsRequest = () => {
    return {
        type: GET_ZONE_ITEMS_REQUEST,
        loading: true
    };
};
export const getZoneItemsSuccess = (zoneItems) => {
    return {
        type: GET_ZONE_ITEMS_SUCCESS,
        loading: false,
        error: null,
        zoneItems
    };
};
export const getZoneItemsError = (error) => {
    return {
        type: GET_ZONE_ITEMS_ERROR,
        loading: false,
        error
    };
};

export const getZoneItems = () => {
    return dispatch => {
        dispatch(getZoneItemsRequest());
        axios.get(apis.ZONES_ITEMS_API , getAxiosTokenConfig())
            .then(response => {
                dispatch(getZoneItemsSuccess(response.data));
            })
            .catch(error => {
                dispatch(getZoneItemsError(errors.GET_ZONE_ITEMS_ERROR));
                notifyError(errors.GET_ZONE_ITEMS_ERROR);
            });
    };
};

// SET CURRENT ZONE
export const SET_CURRENT_ZONE = "SET_CURRENT_ZONE";

export const setCurrentZone = (zoneId) => {
    return dispatch => {
        dispatch({type: SET_CURRENT_ZONE, zoneId});
    }
}

// GET ZONE ITEMS
export const UPDATE_ZONE_ITEMS_COORDS_REQUEST = "UPDATE_ZONE_ITEMS_COORDS_REQUEST";
export const UPDATE_ZONE_ITEMS_COORDS_SUCCESS = "UPDATE_ZONE_ITEMS_COORDS_SUCCESS";
export const UPDATE_ZONE_ITEMS_COORDS_ERROR = "UPDATE_ZONE_ITEMS_COORDS_ERROR";

export const updateZoneItemsCoordsRequest = () => {
    return {
        type: UPDATE_ZONE_ITEMS_COORDS_REQUEST,
        loading: true
    };
};
export const updateZoneItemsCoordsSuccess = (zoneItem) => {
    return {
        type: UPDATE_ZONE_ITEMS_COORDS_SUCCESS,
        loading: false,
        error: null,
        zoneItem
    };
};
export const updateZoneItemsCoordsError = (error) => {
    return {
        type: UPDATE_ZONE_ITEMS_COORDS_ERROR,
        loading: false,
        error
    };
};

export const updateZoneItemsCoords = (itemId, newCoords, resCallback = (result) => null) => {
    return dispatch => {
        dispatch(updateZoneItemsCoordsRequest());
        axios.patch(apis.ZONES_ITEMS_COORDS_API(itemId), newCoords, getAxiosTokenConfig())
            .then(response => {
                dispatch(updateZoneItemsCoordsSuccess(response.data));
                resCallback('success');
            })
            .catch(error => {
                dispatch(updateZoneItemsCoordsError(errors.UPDATE_ZONE_ITEMS_COORDS_ERROR));
                notifyError(errors.UPDATE_ZONE_ITEMS_COORDS_ERROR);
                resCallback('error');
            });
    };
};

export const SET_ZONES = "SET_ZONES"; 


// WEBPACK FOOTER //
// ./src/store/actions/zones.js